// recoil/report/reportFilterState.js
import { atom } from "recoil";

export const reportFilterState = atom({
  key: "reportFilterState",
  default: {},
});
